import { t } from "ttag";

import { getUserIsAdmin } from "metabase/current-user";
import type { GitSyncSetupMenuItemProps } from "metabase/plugins/types";
import { useSelector } from "metabase/redux";
import { useSetting } from "metabase/settings";
import { FixedSizeIcon, Text, Tooltip, UnstyledButton } from "metabase/ui";

import S from "./GitSyncSetupMenuItem.module.css";

const TOOLTIP_OPEN_DELAY = 1000;

export const GitSyncSetupMenuItem = (props: GitSyncSetupMenuItemProps) => {
  const { isNavbarOpened, onClick } = props;
  const isAdmin = useSelector(getUserIsAdmin);
  const isRemoteSyncEnabled = useSetting("remote-sync-enabled");
  // Only show the "Set up remote sync" menu item when user is admin and remote sync is not yet enabled
  const isVisible = isAdmin && !isRemoteSyncEnabled;

  if (isVisible) {
    return (
      <Tooltip
        label={t`Set up remote sync`}
        position="right"
        openDelay={TOOLTIP_OPEN_DELAY}
        disabled={isNavbarOpened}
      >
        <UnstyledButton
          aria-label={t`Set up remote sync`}
          bdrs="sm"
          className={S.tab}
          onClick={onClick}
          p="0.5rem"
        >
          <FixedSizeIcon name="git_branch" className={S.icon} />
          {isNavbarOpened && <Text lh="sm">{t`Set up remote sync`}</Text>}
        </UnstyledButton>
      </Tooltip>
    );
  }

  return null;
};
